export default "__VITE_ASSET__5c3c902a__"